import { useBreakpointDown } from '@travel-frontend/core';
export const useImageGalleryPreview = ({
  images: imagesOption
}) => {
  // @FIXME we should be using container queries here
  const smDown = useBreakpointDown('sm');
  const layout = smDown ? 'small' : 'large';
  const images = Array.from({
    length: 5
  }, (_, index) => imagesOption[index] || {
    url: '',
    alt: ''
  });
  return {
    layout,
    images
  };
};